
const DevadminDashboard = () => {
    
    return (
        <div className="mjsdev-main">
            <h2>Welcome Dev Admin !!</h2>
        </div>
    );
};

export default DevadminDashboard;
